import { InjectionToken } from '@angular/core';
import { CountryName } from '../models/country/country-name.enum';

export const COUNTRY_NAME = new InjectionToken<CountryName>('Country Name');
